import { Store } from "@bluframe/mightychroma-mightytool-frontend-types"

import vendor from "./vendor"

const store: Store = {
  createdAt: "2024-06-12T12:22:00.000Z",
  id: "622e9566-4438-4a1b-ab26-f30f0313fd8a",
  isInternationalShipping: true,
  isPublished: true,
  publishedAt: "2024-06-12T12:22:00.000Z",
  updatedAt: "2024-06-12T12:22:00.000Z",
  url: "https://vinegarsyndrome.com",
  vendor
}

export default store
